module.exports = __webpack_public_path__ + "static/img/swiper_01.1f56d40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/refluxCustomer/swiper_01.png
// module id = oyFG
// module chunks = 1